import { useState, useEffect } from 'react';

export function useScrollSpy(sectionIds: string[], offset: number = 100) {
    const [activeSection, setActiveSection] = useState<string>(sectionIds[0] || '');
    useEffect(() => {
        const handleScroll = () => {
            for (const id of sectionIds) {
                const element = document.getElementById(id);
                if (element) {
                    const rect = element.getBoundingClientRect();
                    if (rect.top <= offset && rect.bottom >= offset) {
                        setActiveSection(id);
                        break;
                    }
                }
            }
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll(); // инициализация при монтировании
        return () => window.removeEventListener('scroll', handleScroll);
    }, [sectionIds, offset]);
    return activeSection;
}
